import React, { useContext, useEffect } from "react";
import { Box, Grid } from "@mui/material";
import { useForm } from "react-hook-form";
import { FormattedMessage } from "react-intl";
import { BaseButton, BaseFormCard, BaseTextField } from "../base";
import UserContext from "../../services/user/user";
import {
  ECAxiosAPI,
  EcAuthContext,
  EcUserDataContext
} from "@eclear-ag/ec-common-ui";

import AutoFillContext from "../../services/user/auto-fill-signup";

const UserInfo = (props) => {
  const { disable, showSave } = props;

  const {
    handleSubmit,
    formState: { errors },
    control,
    reset,
    getValues
  } = useForm({
    mode: "onChange",
    defaultValues: {
      firstName: "",
      lastName: "",
      email: ""
    }
  });

  const { isUserAuthenticated } = useContext(EcAuthContext);
  const { userData, setUserData } = useContext(EcUserDataContext);
  const { setIsSaveSuccess, setIsSnackBarVisible } = useContext(UserContext);
  const { autoFillData } = useContext(AutoFillContext);

  const [isSaving, setIsSaving] = React.useState(false);

  // Mirror the previous EformBuilder data resolution: in the signup/login flows
  // the values come from autoFillData; in manage-profile they come from the
  // loaded userData.userInfo. The field falls back through both, then empty.
  useEffect(() => {
    reset({
      firstName:
        userData.userInfo?.firstName || autoFillData?.firstName || "",
      lastName: userData.userInfo?.lastName || autoFillData?.lastName || "",
      email: userData.userInfo?.email || autoFillData?.email || ""
    });
  }, [userData, autoFillData, reset]);

  const onSubmit = async () => {
    setIsSaving(true);
    const EC_AUTH_BE_V2 = () => {
      return window.location.host.includes("localhost")
        ? `https://dev.eclear-solutions.com/ec-authorization-be/v2/`
        : `https://${window.location.host}/ec-authorization-be/v2/`;
    };

    const data = {
      id: userData.userInfo.id,
      firstName: getValues("firstName"),
      lastName: getValues("lastName")
    };

    await ECAxiosAPI.put(
      `${EC_AUTH_BE_V2()}merchant/${userData.companyId}/users`,
      data,
      {
        userId: userData.userInfo.id
      }
    )
      .then((res) => {
        setIsSaveSuccess(true);
        setUserData({
          ...userData,
          userInfo: {
            ...userData.userInfo,
            firstName: res.firstName,
            lastName: res.lastName
          }
        });
      })
      .catch((err) => {
        console.log("Erroer updating user info: ", err);
        setIsSaveSuccess(false);
      });
    setIsSaving(false);
    setIsSnackBarVisible(true);
  };

  return (
    <BaseFormCard
      title="userInformation"
      onSubmit={handleSubmit(onSubmit)}
      footerJustify="flex-end"
      footer={
        showSave ? (
          <BaseButton
            type="submit"
            variant="filled"
            disabled={isSaving}
            loading={isSaving}
            data-testid="save-button"
          >
            <FormattedMessage id="save" />
          </BaseButton>
        ) : undefined
      }
    >
      <Box
        sx={{
          padding: "16px",
          display: "flex",
          flexDirection: "column",
          gap: "16px"
        }}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <BaseTextField
              errors={errors}
              control={control}
              label={"firstName"}
              required
              disabled={disable || false}
              inputProps={{
                "data-testid": "first-name-input"
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <BaseTextField
              errors={errors}
              control={control}
              label={"lastName"}
              required
              disabled={disable || false}
              inputProps={{
                "data-testid": "last-name-input"
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <BaseTextField
              errors={errors}
              control={control}
              label={"email"}
              disabled
              inputProps={{
                "data-testid": "email-input"
              }}
            />
          </Grid>
        </Grid>
      </Box>
    </BaseFormCard>
  );
};

export default UserInfo;
